"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxTd = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var CheckBoxTd = function (props) {
    var _a = props.cell, text = _a.text, state = _a.state, colSpan = _a.colSpan, path = _a.path, rowSpan = _a.rowSpan;
    var styles = props.style;
    var onChangeV = props.onValueUpdate;
    return ((0, jsx_runtime_1.jsx)("td", __assign({ style: styles, colSpan: colSpan, rowSpan: rowSpan }, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ style: { marginBottom: 0 }, validateStatus: props.required && props.required ? 'error' : undefined }, { children: (0, jsx_runtime_1.jsx)(antd_1.Checkbox, __assign({ onChange: function (s) { return (onChangeV || lodash_1.noop)(path, s); }, checked: state }, { children: text })) })) })));
};
exports.CheckBoxTd = CheckBoxTd;
